import React from 'react';

const AIContainerContext = React.createContext('aiContainerContext');

export const AIContainerContextProvider = AIContainerContext.Provider;

export default AIContainerContext;
